export default "__VITE_ASSET__CVKU6Gbd__"